interface DemoInfoBoxProps {
    description: React.ReactNode;
    example: string;
}

export const DemoInfoBox = ({ description, example }: DemoInfoBoxProps) => {
    return (
        <div className="bg-base-200 rounded-[20px] p-6 border border-base-300">
            <p className="text-base font-medium font-outfit leading-6 text-base-content/80">
                {description}
            </p>
            <p className="text-sm font-normal font-outfit leading-5 text-base-content/60 mt-2">
                Example: <code className="px-2 py-1 bg-base-300 rounded text-sm">{example}</code>
            </p>
        </div>
    );
};